import { render } from "./RealtimeUploadTotalSize.vue?vue&type=template&id=be880754&ts=true"
import script from "./RealtimeUploadTotalSize.vue?vue&type=script&lang=ts"
export * from "./RealtimeUploadTotalSize.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__